__turbopack_context__.v({
  "has_drop_down": "xpFxCW_has_drop_down",
  "my_list_icon": "xpFxCW_my_list_icon",
  "my_list_link": "xpFxCW_my_list_link",
  "my_list_menu": "xpFxCW_my_list_menu",
  "my_list_menu_inner": "xpFxCW_my_list_menu_inner",
  "my_list_menu_intro": "xpFxCW_my_list_menu_intro",
  "my_list_menu_item": "xpFxCW_my_list_menu_item",
});
